import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ProductsSection from '../components/ProductsSection';
import ActivityServicesSection from '../components/ActivityServicesSection';
import VideoShowcase from '../components/VideoShowcase';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import { mountainsLayered } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const HomePage = () => {
  const { t } = useLang();
  return (
    <div className="bg-white">
      <Navbar />
      <Hero />

      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
          <p className="text-xs tracking-[0.3em] text-[#c53114] font-semibold uppercase">{t('intro.eyebrow')}</p>
          <h2
            className="mt-3 text-3xl md:text-5xl font-semibold text-[#0b2545] leading-tight"
            style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}
          >
            {t('intro.title')}
          </h2>
          <p className="mt-6 text-[#475569] leading-relaxed text-lg">{t('intro.body')}</p>
        </div>
      </section>

      <ProductsSection limit={6} />
      <ActivityServicesSection />

      <VideoShowcase />

      <section
        className="relative py-32 bg-fixed bg-cover bg-center"
        style={{ backgroundImage: `url('${mountainsLayered}')` }}
      >
        <div className="absolute inset-0 bg-[#0b2545]/70" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 text-center text-white">
          <h3 className="text-3xl md:text-5xl font-semibold" style={{ fontFamily: "'Barlow Condensed', 'Oswald', sans-serif" }}>
            {t('cta.title')}
          </h3>
          <p className="mt-5 text-white/85 max-w-2xl mx-auto leading-relaxed">{t('cta.body')}</p>
          <a
            href="#contatti"
            className="mt-9 inline-flex items-center gap-2 border border-white px-8 py-3 tracking-[0.25em] text-sm uppercase font-semibold hover:bg-white hover:text-[#0b2545] transition-colors"
          >
            {t('cta.button')}
          </a>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
